module.exports = __webpack_public_path__ + "static/media/Closed.3a159cc6.png";